import { ApiService } from './api-services/ApiService';

export interface PeerConsultationRequest {
  requesterId?: string | number;
  responderId?: string | number;
  notes?: string;
  medicalQuestion?: string;
  specialtyNeeded?: string;
  urgency?: 'LOW' | 'MEDIUM' | 'HIGH' | 'URGENT';
}

export interface PeerConsultationResponse {
  id: string | number;
  requester_id: string | number;
  responder_id: string | number;
  status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED';
  notes?: string;
  created_at: string;
  updated_at: string;
}

class PeerConsultationService {
  private api: ApiService;

  constructor() {
    this.api = ApiService.getInstance();
  }

  async create(request: PeerConsultationRequest): Promise<PeerConsultationResponse> {
    const response = await this.api.post<{ status: string; data: PeerConsultationResponse }>(
      '/api/teleconsult/peer',
      request
    );
    return response.data;
  }

  async getById(id: string | number): Promise<PeerConsultationResponse> {
    const response = await this.api.get<{ status: string; data: PeerConsultationResponse[] }>(
      '/api/teleconsult/peer/history'
    );
    const match = (response.data || []).find((item) => String(item.id) === String(id));
    if (!match) {
      throw new Error('Consultation peer introuvable');
    }
    return match;
  }

  async updateStatus(
    id: string | number,
    status: 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED'
  ): Promise<PeerConsultationResponse> {
    const endpoint =
      status === 'IN_PROGRESS'
        ? `/api/teleconsult/peer/${id}/accept`
        : status === 'COMPLETED'
          ? `/api/teleconsult/peer/${id}/complete`
          : `/api/teleconsult/peer/${id}/decline`;
    const response = await this.api.post<{ status: string; data: PeerConsultationResponse }>(
      endpoint
    );
    return response.data;
  }
}

export default new PeerConsultationService();
